import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./index.css";
import Banner from "../../common/Banner";
import { INFORMATION } from "../Banners/constants";

const WarningBanner = ({ warningMessage, className, render }) => (
  <Banner
    ariaLive="polite"
    className={classnames(styles.warningBanner, styles.show, className)}
    message={warningMessage}
    outerContent={render}
    iconClass={INFORMATION}
  />
);

WarningBanner.propTypes = {
  warningMessage: PropTypes.string.isRequired,
  className: PropTypes.string,
  render: PropTypes.func
};

export default WarningBanner;
